import i18next from 'i18next';

i18next.addResources('es_CL', 'StoreSelector', {
  title: 'Tienda'
});

i18next.addResources('es_CR', 'StoreSelector', {
  title: 'Tienda'
});
